import ContainerFlex from "components/ContainerFlex";
import * as St from "../styles";
import TableAntecipation from "components/TableAntecipation";
import AppButton from "components/AppButton/AppButton";
import { RouteNames } from "routes/routes";
import Endpoints from "services/api/endpoints";
import useApi, { ApiMethod } from "hooks/useApi";
import { useAppDispatch, useAppSelector } from "redux/app/hooks";
import { setLoading, setTitleLoading } from "redux/ui/loadings-slice";
import { useEffect, useState } from "react";
import { showMessage } from "utils/messages";
import { moneyMask } from "utils/mask";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { addValueAntecipationPurchase } from "redux/features/cliente/cliente-slice";
import { addTypeFlowState } from "redux/features/security/security-slice";

interface IAntecipationHistory {
  cartao?: string;
  cpf?: string;
  dataAntecipacao?: string;
  dataFechamento?: string;
  dataPagamento?: string;
  nomeCliente?: string;
  parcelasAntecipadas?: number;
  status?: string;
  valorAntecipacao?: number;
  txId?: string;
  qrcodeBase64?: string;
}

const AntecipationHistory = () => {
  const [list, setList] = useState<IAntecipationHistory[]>([]);
  const [data, setData] = useState<IAntecipationHistory[]>([]);
  const dispatch = useAppDispatch();

  const history = useHistory();

   const {
      cliente: { cpf },
    } = useAppSelector((state) => state.cliente);

  const GetAntecipationsHistory = useApi<any>(
    Endpoints.cobranca.getAntecipationHistory.replace("PARAM_CPF", cpf || '').replace("PARAM_TIPO", "COMPRA"),
    ApiMethod.GET
  );

  const getAntecipationHistory = async () => {
    dispatch(setLoading(true));
    dispatch(setTitleLoading("Carregando últimas antecipações..."));

    const response = await GetAntecipationsHistory.callApi();

    let data: IAntecipationHistory[] = response?.data || [];

    setData(data);

    if (response.status >= 200 && response.status < 300) {
      if (data) {
        const newList = data.map((item) => ({
          status: item?.status === "FATURAR" ? "A FATURAR" : item?.status,
          parcelas: item?.parcelasAntecipadas,
          valor: moneyMask(item?.valorAntecipacao),
          dataPagamento:  item?.dataPagamento ? moment(item?.dataPagamento).format("DD/MM/YYYY") : '-',
          formaPagamento: item?.txId ? "PIX" : "CAIXA"
        }));

        setList(newList);
        dispatch(setLoading(false));

        if (response?.data?.length <= 0) {
           dispatch(setLoading(false));
         showMessage("warning", "Atenção!", "Nenhuma antecipação de compra encontrada.");
        }
      }

    } else {
      dispatch(setLoading(false));
      const { mensagem } = response?.data;
      showMessage("warning", "Atenção!", mensagem);
    }
  };

  useEffect(() => {
    getAntecipationHistory();
    // getAntecipationHistory vem de useApi/e nao e memoizada; incluir causaria
    // refetch em loop a cada render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cpf]);

  const clickVoltar = () => {};

  const headerTable = [
    "Status",
    "Parcelas antecipadas",
    "Valor antecipado",
    "Data do pagamento",
    "Forma pagamento",
    "",
  ];

  const handleNavigateToPix = (rowIndex: number) => {
    const itemOriginal = data[rowIndex];
    dispatch(addValueAntecipationPurchase(Number(itemOriginal?.valorAntecipacao)));
    dispatch(addTypeFlowState("fatura-pix"));

    history.push({
      pathname: RouteNames.PAGAMENTO_PIX_FATURA,
      state: {
        ...itemOriginal,
        qrcodeBase64: itemOriginal?.qrcodeBase64 || null,
        historyAntecipation: true,
      },
    });
    
  }

  return (
    <ContainerFlex>
      <St.TitleH1>Últimas antecipações</St.TitleH1>
      <St.TableScroll>
        <TableAntecipation header={headerTable} data={list} navigate={handleNavigateToPix}/>
      </St.TableScroll>
      <St.FooterFixed>
        <ContainerFlex
          row
          align="flex-start"
          marginTop={3}
          justifyContent="space-between"
        >
          <ContainerFlex row gap="10px">
            <AppButton
              content="Voltar"
              route={RouteNames.ATENDIMENTO_ANTECIPACAO}
              outlined={true}
              click={clickVoltar}
            />
          </ContainerFlex>
        </ContainerFlex>
      </St.FooterFixed>
    </ContainerFlex>
  );
};

export default AntecipationHistory;
